import { render, staticRenderFns } from "./AdminPresidentiView.vue?vue&type=template&id=e11ff652&"
import script from "./AdminPresidentiView.vue?vue&type=script&lang=ts&"
export * from "./AdminPresidentiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports